import ProductCountTag from './ProductCountTag';

export default ProductCountTag;
